/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S3_Li2Inputs */

const tr_iade_iptal_s3_li2 = /** @type {(inputs: Iade_Iptal_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı, iptal veya fesih bildirimini ek bir koşula bağlamaz ve geciktirmez; bildirim üzerine sunulabilecek bir teklif, iptali bağlayıcı bir koşula dönüştürmez. İptal, Platform içinden tek tıkla başlatılabilir; derhal sona erdirme talebi 9. maddedeki kanallardan iletilir.`)
};

const en_iade_iptal_s3_li2 = /** @type {(inputs: Iade_Iptal_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider does not make a cancellation or termination notice subject to any additional condition and does not delay it; an offer made in response to the notice does not make the cancellation conditional. Cancellation can be started within the Platform with a single click; a request for immediate termination is submitted through the channels in clause 9.`)
};

const de_iade_iptal_s3_li2 = /** @type {(inputs: Iade_Iptal_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter knüpft eine Kündigungs- oder Beendigungsmitteilung an keine zusätzliche Bedingung und verzögert sie nicht; ein auf die Mitteilung hin unterbreitetes Angebot macht die Kündigung nicht von einer Bedingung abhängig. Die Kündigung kann in der Plattform mit einem Klick gestartet werden; ein Antrag auf sofortige Beendigung wird über die Kanäle der Ziffer 9 übermittelt.`)
};

const ru_iade_iptal_s3_li2 = /** @type {(inputs: Iade_Iptal_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик не обусловливает уведомление об отмене или расторжении дополнительными условиями и не затягивает его; предложение, сделанное в ответ на уведомление, не превращает отмену в условную. Отмена может быть начата в Платформе одним нажатием; запрос о немедленном прекращении направляется по каналам, указанным в пункте 9.`)
};

/**
* | output |
* | --- |
* | "The Provider does not make a cancellation or termination notice subject to any additional condition and does not delay it; an offer made in response to the n..." |
*
* @param {Iade_Iptal_S3_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s3_li2 = /** @type {((inputs?: Iade_Iptal_S3_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S3_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s3_li2(inputs)
	if (locale === "de") return de_iade_iptal_s3_li2(inputs)
	if (locale === "ru") return ru_iade_iptal_s3_li2(inputs)
	return tr_iade_iptal_s3_li2(inputs)
});